<div class="text-sm leading-relaxed text-gray-800 list-disc pl-4 ">
                    <span class="table-comment">
                        Past performance is not an indicator of future returns. Performance calculation and other information have been prepared in good faith by BNP Paribas in accordance with BNP Paribas’ own internal models and calculation methods and is for your information only. Data included therein may be based on sources believed to be reliable, but no representation or warranty, express or implied, is made that such information is accurate or complete and it should not be relied upon as such. Some indices show Hypothetical Past Performance Data (‘PPD’). This hypothetical PPD is the result of calculations made by BNP Paribas at a given moment on the basis of the parameters selected by BNP Paribas, of market conditions at a given moment and of historical data which should not be used as an indicator of future performance, which may be better or worse than prior results.
                    </span>
  <br/>
  <br/>
  <p>Selected Risk Considerations related to the Indices:</p>
  <ul style="padding:0px 15px;" class="list-disc">
    <li>The methodologies underlying the Indices may not be successful — No assurance can be given that the Indices
      will achieve their goals.
    </li>
    <li>Numerous factors (including, but not limited to, changes in: interest rates, investor expectations, economic
      results, regulations, liquidity) may affect the components of the Indices and the performance of the Indices.
    </li>
    <li>The Indices involve synthetic execution and may not reflect actual market activity.</li>
    <li>The Indices may contain embedded fees, which will reduce performance</li>
    <li>The methodology and rules related to each Index is subject to change</li>
    <li>The Indices have limited historical information and publicly available information on the Indices is limited
    </li>
    <li>Certain Indices incorporate a volatility control mechanism that may limit returns</li>
    <li>Indices that include rebalancing may result in concentration risk and/or be partially or completely uninvested
      and earn no return
    </li>
    <li>Indices that use leverage will have increased exposure to the index components</li>
    <li>These risk considerations may not be exhaustive.  Any potential user of the BNP Paribas Indices should consult
      with financial and other advisors as it deems appropriate.
    </li>
    <li>The information provided on this website should not be construed as legal, financial, tax, accounting or other
      advice.
    </li>
    <li>BNP Paribas shall have no liability for any loss arising from or related to any use of the BNP Paribas
      Indices
    </li>
  </ul>

  <p>Selected Risk Considerations related to the Hypothetical Performance:</p>
  <ul style="padding:0px 15px;" class="list-disc">
    <li>
      Future performance of the strategies may be worse than past and hypothetical historical results. Certain levels
      are simulated and must be considered hypothetical and illustrative only. The actual performance of the
      strategies may bear little relation to the hypothetical historical results.
    </li>
    <li>
      Hypothetical past performance is based on criteria applied retroactively with the benefit of hindsight and
      knowledge of factors that may have positively affected its performance, and cannot account for all financial
      risk that may affect the actual performance of the strategies.
    </li>
    <li>Hypothetical past performance might not reflect all possible market conditions. The strategies might behave
      differently under other market conditions
    </li>
  </ul>

  <p>
    Little information is available publicly about the Indices; additional information regarding the methodology and
    rules related to the strategies is available upon request.
  </p>
</div>
